// extracted by mini-css-extract-plugin
module.exports = {"page":"CustomDataPage_page__3bC1P","active":"CustomDataPage_active__1-HMx"};